import React from 'react';
import { ClearIndicatorProps, components, GroupBase } from 'react-select';

import { Icon } from '../../Icon';

import styles from './MultiSelectComponents.module.scss';

function ClearIndicator<T, IsMulti extends boolean, Group extends GroupBase<T>>(
  props: ClearIndicatorProps<T, IsMulti, Group>,
): JSX.Element {
  return (
    <>
      <components.ClearIndicator {...props}>
        <Icon icon="close-tooltip"
              size={props.selectProps.indicatorSize}
              className={styles.clearIndicatorIcon} />
      </components.ClearIndicator>
      <div className={styles.divider} />
    </>

  );
}

export default ClearIndicator;
